var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/user-menu/UserMenu.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useEffect } from 'react';
import HeaderContext from '../../HeaderContext';
import { useUserMenuQueryLazyQuery } from './UserMenu.generated';
import RenderUserMenu from './RenderUserMenu';

// TODO: Rewrite this in local scope after gettig translations
import getUserLinks from '../../../components/UserDropDown/getUserLinks';
var parseUsername = function parseUsername(username) {
  return username.length > 15 ? "".concat(username.substring(0, 9), "...") : username;
};
var UserMenu = function UserMenu() {
  var _useContext = useContext(HeaderContext),
    lang = _useContext.lang,
    isEUDC = _useContext.isEUDC;
  var _useUserMenuQueryLazy = useUserMenuQueryLazyQuery(),
    _useUserMenuQueryLazy2 = _slicedToArray(_useUserMenuQueryLazy, 2),
    fetch = _useUserMenuQueryLazy2[0],
    _useUserMenuQueryLazy3 = _useUserMenuQueryLazy2[1],
    loading = _useUserMenuQueryLazy3.loading,
    error = _useUserMenuQueryLazy3.error,
    data = _useUserMenuQueryLazy3.data;
  useEffect(function () {
    fetch();
  }, []);
  if (loading) {
    return null;
  }
  if (error || !(data !== null && data !== void 0 && data.user)) {
    var _userLinks = getUserLinks();
    return /*#__PURE__*/React.createElement(RenderUserMenu, {
      username: "My Account",
      menuItems: _userLinks,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 12
      }
    });
  }
  var _data$user = data.user,
    username = _data$user.username,
    preferences = _data$user.preferences,
    features = _data$user.features,
    linkedIdentities = _data$user.linkedIdentities,
    teamMembership = _data$user.teamMembership;
  var isTeamOwner = (teamMembership === null || teamMembership === void 0 ? void 0 : teamMembership.memberType) === 'ACCOUNT_OWNER';
  var isEnterpriseAccount = teamMembership === null || teamMembership === void 0 ? void 0 : teamMembership.isEnterprise;
  var isNonEnterpriseGroupAdmin = !isEnterpriseAccount && isTeamOwner;
  var paidBenchmarksEnabled = preferences === null || preferences === void 0 ? void 0 : preferences.paidBenchmarksEnabled;
  var plansBenchmarksEnabled = features === null || features === void 0 ? void 0 : features.plansBenchmarksEnabled;
  var liteLibraryEnabled = features === null || features === void 0 ? void 0 : features.liteLibraryEnabled;
  var libraryEnabled = !!(teamMembership || liteLibraryEnabled);
  var linked = linkedIdentities !== null && linkedIdentities !== void 0 ? linkedIdentities : {
    totalCount: 0
  };
  var hasMultipleLinkedIdentities = linked.totalCount > 1;
  var userLinks = getUserLinks(isNonEnterpriseGroupAdmin, paidBenchmarksEnabled, libraryEnabled, plansBenchmarksEnabled, isEnterpriseAccount, lang, isEUDC, hasMultipleLinkedIdentities);
  return /*#__PURE__*/React.createElement(RenderUserMenu, {
    username: parseUsername(username),
    menuItems: userLinks,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 5
    }
  });
};
export default UserMenu;
//# sourceMappingURL=UserMenu.js.map